import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import _ from 'lodash';
import cn from 'classnames';
import './ShopMySelect.scss';

import SelectOption from './SelectOption';

const ShopMySelect = forwardRef((props, ref) => {
  /*
    A Styled Select Component that can be used to select options from a dropdown.

      Example:
        <Select
          noStyling
          disableSearch
          options={[
            { value: 1, label: 'Option 1', sublabel: 'Sublabel 1'},
            { value: 2, label: 'Option 2', sublabel: 'Sublabel 2'},
          ]}
          value={value}
          placeholder='Select an option'
          onChangeValue={newValue => setValue(newValue)}
          isSearching={false}
          isDisabled={false}
          isLoading={false}
        />
  */

  let selectedOption = null;
  if (props.isMulti) {
    selectedOption = props.value && _.flatten(_.map(props.options, o => o.options || [])).filter(option => props.value.includes(option.value));
  } else {
    selectedOption =
      !_.isNil(props.value) && // Not set
      (props.options.find(option => _.isEqual(option.value, props.value)) || // One level
        _.flatten(_.map(props.options, o => o.options || [])).find(option => _.isEqual(option.value, props.value))); // Two levels
  }
  const onChange = optionOrOptions => {
    if (props.isMulti) {
      let newValues = optionOrOptions;
      const recentlyAddedOption = _.last(optionOrOptions);
      if (recentlyAddedOption?.removeValuesOnSelect) {
        newValues = newValues.filter(option => !recentlyAddedOption.removeValuesOnSelect.includes(option.value));
      }
      props.onChangeValue(newValues ? newValues.map(o => o.value) : null);
    } else {
      props.onChangeValue(optionOrOptions?.value);
    }
  };

  return (
    <>
      <Select
        ref={ref}
        isMulti={props.isMulti}
        className={cn('shopmy-select', props.className, {
          'with-standard-styling': !props.noStyling && !props.isNewSmallerStyling,
          'new-smaller-styling': !props.noStyling && props.isNewSmallerStyling,
          'without-styling': props.noStyling,
          'is-dark': props.isDark
        })}
        classNamePrefix='shopmy-select'
        options={props.options}
        value={selectedOption}
        onChange={onChange}
        components={{
          Option: SelectOption,
          ClearIndicator: () => null
        }}
        placeholder={props.placeholder}
        isSearchable={!props.disableSearch}
        isDisabled={props.isDisabled}
        isLoading={props.isLoading}
        menuIsOpen={props.menuIsOpen}
        onMenuClose={props.onMenuClose}
      />
    </>
  );
});

ShopMySelect.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  onChangeValue: PropTypes.func.isRequired,
  menuIsOpen: PropTypes.bool,
  onMenuClose: PropTypes.func,

  // Optional Functionality
  disableSearch: PropTypes.bool, // To turn off the ability to search filters

  // Optional Styling
  isDark: PropTypes.bool, // To make the select dark for white backgrounds
  isNewSmallerStyling: PropTypes.bool, // To use the new smaller styling
  className: PropTypes.string, // To add a class to the select
  noStyling: PropTypes.bool, // To turn off the styling
  isMulti: PropTypes.bool // To make the select multi-select
};

export default ShopMySelect;
